export default "__VITE_ASSET__hO8_7muA__"